module.exports = __webpack_public_path__ + "media/images/badge/partita-fortunata_secondary-fe18fd6529baf490a102565738d88b9c.png";